import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { config } from "./lib/config";
import "./index.css";

// Tag the tab title with the stage so local/dev/prod are easy to tell apart
// when several are open side by side. Prod keeps the plain title.
if (config.stage !== "prod") {
  document.title = `${document.title} (${config.stage})`;
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
